import SelectorFilter from '../hierarchySelector/tree/SelectorFilter'

export default class ReportsCPSelectorFilter extends SelectorFilter {
    constructor({
        tree,
        searchIndex,
        allActiveSet,
        projectsWithMaSet,
        accessibleCustomersSet,
        showOnlyManageable = false
    }) {
        super(tree, searchIndex, allActiveSet)
        this.savedProjectsWithMaSet = projectsWithMaSet
        this.projectsWithMaSet = showOnlyManageable ? projectsWithMaSet : null
        //set of customers containing manageable projects
        this.accessibleCustomersSet = accessibleCustomersSet
    }

    hasNoFilter() {
        return super.hasNoFilter() && !this.projectsWithMaSet
    }

    doFilter() {
        if (!this.projectsWithMaSet)
            return super.doFilter()

        let result;
        //keywordSet - set of nodes representing result of search by some specified keyword.
        //If keywordSet is presented then we should return result of search in set of manageable projects.
        // Set of selected nodes(selectedOnlySet) is not taken into account when searching.
        if (this.keywordSet) {
            result = this.projectsWithMaSet.intersection(this.keywordSet)
            let resultWithActiveOnlySet = this.safeIntersection(result, this.activeOnlySet)

            // If there is no active projects or customers with a specified keyword found
            // then return result of search in archived and manageable projects
            result = resultWithActiveOnlySet.isEmpty() ? result : resultWithActiveOnlySet
        } else { //If there is no keywordSet then result is intersection of all other sets
            result = this.safeIntersection(this.projectsWithMaSet, this.activeOnlySet)
            result = this.safeIntersection(result, this.selectedOnlySet)
        }

        return result
    }

    getVisibleNodeSet(selectedNodeSet) {
        const visibleProjectNodes = this.safeIntersection(super.getVisibleNodeSet(selectedNodeSet), this.projectsWithMaSet)
        const visibleCustomerNodes = this.accessibleCustomersSet.intersection(selectedNodeSet)
        return visibleProjectNodes.union(visibleCustomerNodes)
    }

    setShowOnlyManageable(onlyManageable) {
        if (onlyManageable) {
            this.projectsWithMaSet = this.savedProjectsWithMaSet
        } else {
            this.projectsWithMaSet = null
        }

        this.reFilter()
    }

}



// WEBPACK FOOTER //
// ./web/js/cp_selector/ReportsCPSelectorFilter.js